import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

import {Button} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Button';

export const Content = styled(Flex)(
  ({theme}) => css`
    padding: 16px;
    min-width: auto;

    ${theme.respondTo(
      'sm',
      css`
        min-width: 219px;
        padding: 8px 12px;
        ${Button} {
          padding: 8px 16px;
        }
      `
    )};

    ${theme.respondTo(
      'md',
      css`
        max-width: 250px;
        padding: 8px 24px;
      `
    )};

    ${theme.respondTo(
      'lg',
      css`
        min-width: 300px;
        padding: 8px 80px 8px 24px;
      `
    )};
  `
);
